import React, { createContext, useReducer } from 'react';
import keys from '../keys.json';

const { linkKeys } = keys;
const initialState = {
  activeLinkKey: linkKeys?.addClub,
  selectedClubs: [],
};
const clubsContext = createContext(initialState);
const { Provider } = clubsContext;

const ClubsProvider = ({ children }) => {
  const [state, dispatch] = useReducer((contextState, action) => {
    const typeOptions = {
      SET_USER_CLUBS: {
        ...contextState,
        userClubs: action.clubs,
      },
      SET_LINK_KEY: {
        ...contextState,
        activeLinkKey: action.key,
      },
      SET_SEARCHED_AND_SELECTED_CLUBS: {
        ...contextState,
        searchedClubs: action.searchedClubs,
        selectedClubs: action.selectedClubs,
      },
    };

    if (typeOptions[action.type]) {
      return typeOptions[action.type];
    }

    throw new Error();
  }, initialState);

  return <Provider value={{ state, dispatch }}>{children}</Provider>;
};

export { clubsContext, ClubsProvider };
